import PropTypes from 'prop-types';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import FilterCheckbox from './FilterCheckbox';
import { jsx as _jsx } from "react/jsx-runtime";
function IncludeOpenTicketsCheckbox(props) {
  const includeOpenTickets = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters.includeOpenTickets);
  return /*#__PURE__*/_jsx(FilterCheckbox, {
    "data-test-id": "filter-checkbox",
    defaultValue: includeOpenTickets,
    helpLangPath: "app.filter.panel.includeOpenTickets.help",
    labelLangPath: "app.filter.panel.includeOpenTickets.label",
    onCheck: props.onCheck
  });
}
IncludeOpenTicketsCheckbox.propTypes = {
  onCheck: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(IncludeOpenTicketsCheckbox);